<template>
  <section class="login">
    <img
      class="login__logo"
      src="~@/assets/img/SB-Images/app-logo.svg"
      alt="AI Number" >

    <h1>Email sent!</h1>
    <div class="login-additionals">
      <span>An email is on its way to you. Follow the instructions to reset your password.</span>
      <br> <br>
      <span>Didn't get the email? Check your spam folder or
        <span
          class="login__forgot-pass"
          @click="resend">resend</span>.
      </span>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ResetPasswordSent',
  props: {
    email: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      resetPasswordRequest: 'user/resetPasswordRequest',
    }),
    resend() {
      this.resetPasswordRequest({
        email: this.email,
      });
    },
  },
};
</script>
